export const API_BASE_URL = "https://api.fastbetter.com/aut24"; // Test
//export const API_BASE_URL = "https://api.fastbetter.com/fstb20251";
export const VERSION_CHECK_API = API_BASE_URL + "/pre/opt/products/version";
export const FREE_EMAILS_LIST = API_BASE_URL + "/pre/prouseremail";

// export const GOOGLE_CLIENT_ID =  "994159451716-tjfk81tujh94go3oidn7k1io0okk06df.apps.googleusercontent.com"; // OLD fastbetter gmail
// export const GOOGLE_CLIENT_ID =
//   "815525209241-584mphqo5tdoadu3jjubmjd5f0v5f54v.apps.googleusercontent.com"; // OLD vtrni gmail

export const GOOGLE_CLIENT_ID =
  "1082681134236-m1gv7612h1s4di2l4s6orfkpsc31dmrp.apps.googleusercontent.com"; // appstorefastbetter@votariniltd.com
